import { IMemberDTO, MemberRole } from '../../interfaces/member';

export const isAdmin = (member: IMemberDTO) => {
  return member.role.some((role) => {
    return role === MemberRole.Admin || role === MemberRole.Owner;
  });
};
